import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { id: "products" };
const _hoisted_2 = { class: "flex items-center mb-4" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 0,
    class: "lg:flex items-center mb-4"
};
const _hoisted_6 = { class: "lg:w-1/2 lg:mr-2" };
const _hoisted_7 = { class: "w-full h-56" };
const _hoisted_8 = { class: "text-slate-600" };
const _hoisted_9 = { class: "py-2 text-right" };
const _hoisted_10 = ["href"];
const _hoisted_11 = { class: "py-2 text-right" };
const _hoisted_12 = { class: "py-2 text-right" };
const _hoisted_13 = ["href"];
const _hoisted_14 = { class: "py-2 text-right" };
const _hoisted_15 = { class: "py-2 text-right" };
const _hoisted_16 = ["href"];
const _hoisted_17 = { class: "lg:w-1/2 lg:ml-2" };
const _hoisted_18 = { class: "w-full h-56" };
const _hoisted_19 = { class: "text-slate-600" };
const _hoisted_20 = { class: "p-2 text-right" };
const _hoisted_21 = { class: "p-2 text-right" };
const _hoisted_22 = { class: "p-2 text-right" };
const _hoisted_23 = { class: "p-2 text-right" };
const _hoisted_24 = { class: "p-2 text-right" };
const _hoisted_25 = { class: "p-2 text-right" };
const _hoisted_26 = { class: "flex items-center mb-4" };
const _hoisted_27 = { key: 2 };
const _hoisted_28 = { class: "my-loading" };
const _hoisted_29 = {
    key: 3,
    class: "grid gap-6 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4"
};
const _hoisted_30 = { class: "overflow-hidden relative col-span-1 bg-slate-50 rounded-lg shadow divide-y divide-slate-200 rounded-2xl" };
const _hoisted_31 = {
    key: 0,
    class: "absolute top-4 -left-8 bg-brand-500 text-white font-medium text-sm shadow-lg -rotate-45 px-8 py-1 uppercase"
};
const _hoisted_32 = { class: "w-full flex items-center justify-between space-x-6 rounded-t-2xl bg-slate-200 p-2" };
const _hoisted_33 = ["src", "alt"];
const _hoisted_34 = { class: "flex px-5 py-3" };
const _hoisted_35 = { class: "flex-1" };
const _hoisted_36 = { class: "flex sub-heading font-medium text-sm text-slate-700" };
const _hoisted_37 = { class: "text-slate-400 text-xs" };
const _hoisted_38 = { class: "flex items-center" };
const _hoisted_39 = { class: "font-medium text-brand-600 text-center" };
const _hoisted_40 = { class: "my-loading" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Loading = _resolveComponent("Loading");
    const _component_ConfirmationModal = _resolveComponent("ConfirmationModal");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (!_ctx.account.isLoaded())
                ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Manage Account"))
                : (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.account.data.name), 1)),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.account.navigation.goBack && _ctx.account.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back"),
                (_ctx.account.isLoaded() && _ctx.permissions.isProgrammeManager())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'admin.account.edit', params: { account: _ctx.account.data.slug } },
                        class: "flex btn ml-2 items-center"
                    }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Edit Account ", -1)
                            ]))]),
                        _: 1
                    }, 8, ["to"]))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.account.isLoaded())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("section", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                        _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-800",
                                    colspan: "2"
                                }, "Details")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_8, [
                            _createElementVNode("tr", null, [
                                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Name", -1)),
                                _createElementVNode("td", _hoisted_9, [
                                    _createTextVNode(_toDisplayString(_ctx.account.data.name) + " <", 1),
                                    _createElementVNode("a", {
                                        href: _ctx.account.data.endpoint,
                                        class: "text-brand-600 hover:text-brand-800"
                                    }, _toDisplayString(_ctx.account.data.endpoint), 9, _hoisted_10),
                                    _cache[4] || (_cache[4] = _createTextVNode(">", -1))
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Status", -1)),
                                _createElementVNode("td", _hoisted_11, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["status-box", {
                                                'status-active': _ctx.account.data.active === true,
                                                'status-cancelled': _ctx.account.data.active === false,
                                            }])
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.account.data.active ? 'Active' : 'Inactive'), 1),
                                        _cache[6] || (_cache[6] = _createElementVNode("span", null, [
                                            _createElementVNode("span"),
                                            _createElementVNode("span")
                                        ], -1))
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Processor Endpoint", -1)),
                                _createElementVNode("td", _hoisted_12, [
                                    _createElementVNode("a", {
                                        href: _ctx.account.data.processor_endpoint,
                                        class: "text-brand-600 hover:text-brand-800",
                                        target: "_blank"
                                    }, _toDisplayString(_ctx.account.data.processor_endpoint), 9, _hoisted_13)
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Processor Username", -1)),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.account.data.processor_username), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Simfoni Retail Endpoint ", -1)),
                                _createElementVNode("td", _hoisted_15, [
                                    _createElementVNode("a", {
                                        href: _ctx.account.data.simfoni_retail_endpoint,
                                        class: "text-brand-600 hover:text-brand-800",
                                        target: "_blank"
                                    }, _toDisplayString(_ctx.account.data.simfoni_retail_endpoint), 9, _hoisted_16)
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                        _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-800",
                                    colspan: "2"
                                }, "Metrics")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_19, [
                            _createElementVNode("tr", null, [
                                _cache[12] || (_cache[12] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Available Products", -1)),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.account.metrics.active_products), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Prepaid Products", -1)),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.account.metrics.prepaid_products), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[14] || (_cache[14] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Campaigns", -1)),
                                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.account.metrics.campaign_count), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Upcoming Campaigns", -1)),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.account.metrics.upcoming_campaigns), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Active Campaigns", -1)),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.account.metrics.active_campaigns), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Expired Campaigns", -1)),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.account.metrics.expired_campaigns), 1)
                            ])
                        ])
                    ])
                ])
            ]))
            : (_openBlock(), _createBlock(_component_Loading, {
                key: 1,
                message: "Loading Account"
            })),
        _createElementVNode("div", _hoisted_26, [
            _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "flex-1 font-medium mb-4 text-xl" }, "Products", -1)),
            _createElementVNode("nav", null, [
                (_ctx.permissions.isAdmin())
                    ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
                        key: 0,
                        buttonClass: "btn mr-2",
                        buttonText: "Synchronise Products",
                        onConfirmAction: _cache[1] || (_cache[1] = ($event) => (_ctx.synchroniseProducts()))
                    }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                    _createElementVNode("svg", {
                                        class: "h-6 w-6 text-brand-600",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        role: "img",
                                        focusable: "false",
                                        "aria-label": "Warning"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                        })
                                    ])
                                ], -1),
                                _createElementVNode("div", { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }, [
                                    _createElementVNode("h3", {
                                        class: "text-lg leading-6 font-medium text-slate-900",
                                        id: "modal-title"
                                    }, "Synchronise Products"),
                                    _createElementVNode("div", { class: "mt-2" }, [
                                        _createElementVNode("p", { class: "text-sm text-slate-500" }, "Are you sure you would like to synchronise products to this account?")
                                    ])
                                ], -1)
                            ]))]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.productSyncing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_Loading, { message: " Performing Product Synchronisation, Please Wait" })
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.product_index.hasResults() && !_ctx.productSyncing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_index.getData(), (product) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (product.prepaid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Prepaid"))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("img", {
                                class: "object-contain h-48 rounded-2xl mx-auto",
                                src: product.image,
                                alt: product.name
                            }, null, 8, _hoisted_33)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.f.ellipsis(product.name, 20)), 1),
                                _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.f.ellipsis(product.sku, 20)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("p", _hoisted_39, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["status-box", {
                                                'status-active': product.active === true,
                                                'status-cancelled': product.active === false,
                                            }])
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(product.active ? 'Active' : 'Inactive'), 1)
                                    ], 2)
                                ])
                            ])
                        ])
                    ]));
                }), 256))
            ]))
            : _createCommentVNode("", true),
        (!_ctx.productSyncing)
            ? (_openBlock(), _createBlock(_component_VueEternalLoading, {
                key: 4,
                load: _ctx.load,
                "is-initial": _ctx.isInitial,
                "onUpdate:isInitial": _cache[2] || (_cache[2] = ($event) => ((_ctx.isInitial) = $event))
            }, {
                loading: _withCtx(() => [
                    _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_Loading, { message: "Loading Products" })
                    ])
                ]),
                "no-more": _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("div", { class: "my-no-more" }, [
                            _createElementVNode("div", { class: "my-6 text-center" }, [
                                _createElementVNode("a", {
                                    href: "#products",
                                    class: "flex justify-center"
                                }, [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-5 w-5 mr-2",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        "stroke-width": "2"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                        })
                                    ]),
                                    _createTextVNode(" Top of Page ")
                                ])
                            ])
                        ], -1)
                    ]))]),
                "no-results": _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                            _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-20 w-20 mx-auto",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                    })
                                ])
                            ]),
                            _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Products Available"),
                            _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " We could not find any products, please synchronise using the button above. ")
                        ], -1)
                    ]))]),
                error: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                            _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-20 w-20 mx-auto",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    role: "img",
                                    focusable: "false",
                                    "aria-label": "An Error Occurred"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                    })
                                ])
                            ]),
                            _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                            _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                        ], -1)
                    ]))]),
                _: 1
            }, 8, ["load", "is-initial"]))
            : _createCommentVNode("", true)
    ]));
}
